export const UserManagerListColumnsModel = [
  {
    label: 'Name',
    property: 'name',
    type: 'string'
  },
  {
    label: 'Email',
    property: 'email',
    type: 'string'
  },
  {
    label: 'Status',
    property: 'status',
    type: 'string'
  }
];
